angular.module('callX').controller('HangupModalCtrl', ['$scope', '$modalInstance', '$state', 'UserService', 'object', function($scope, $modalInstance, $state, UserService, object) {

    $scope.obj = object;
    $scope.id = $scope.obj.id; 
    // console.log( $scope.obj,"hit this object")
  
    $scope.cancel = function() {
      $modalInstance.close('cancel');
    };
     
    $scope.ok = function() {
      $modalInstance.close('ok')
        var callbacks = {
          success: function(data) {
            $modalInstance.close('ok')
          },
          failure: function(data) {
            toaster.pop('error', 'Error', data.message);
          }
        };
      // UserService.onEndCall($scope.id, callbacks)
    }

}]);